import {Component} from '@angular/core';
import {RepositoryService} from '../../../smoothr-web-app-core/services/repository/repository.service';
import {environment} from '../../../environments/environment';
import {NavigationService} from 'src/app/services/navigation.service';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject} from 'rxjs';
import {FormControl, FormGroup} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {NavController} from '@ionic/angular';

type faqItem = {
	title: string;
	subTitle: string;
	description: string;
	isOpen: boolean;
};

type faqData = {
	title: string;
	isOpen: boolean;
	subItem: faqItem[];
};

@Component({
	selector: 'app-tos',
	templateUrl: './tos.page.html',
	styleUrls: ['tos.page.scss']
})
export class TosPage {
	static url = 'tos';
	environment = environment;
	form: FormGroup;

	faqArray: faqData[] = [
		{
			title: this.translate.instant('tos_page.mainItem.title1'),
			isOpen: false,
			subItem: [
				{
					title: this.translate.instant('tos_page.subItem.title1'),
					subTitle: this.translate.instant('tos_page.subItem.subtitle1'),
					description: this.translate.instant('tos_page.subItem.description1'),
					isOpen: false
				}
			]
		}
	];
	public faqSubject$ = new BehaviorSubject<faqData[]>(this.faqArray);
	public searchInput = new FormControl('');

	constructor(
		private repository: RepositoryService,
		private navigationService: NavigationService,
		private translate: TranslateService,
		private navCtrl: NavController
	) {
		this.searchInput.valueChanges.pipe(debounceTime(150)).subscribe(v => {
			this.filterFaq(v);
		});
	}

	checkIncludes(baseString: string, searchLow: string) {
		return baseString.toLocaleLowerCase().includes(searchLow);
	}

	filterFaq(search: string) {
		let faqArray = this.faqArray;
		const searchLow = search.toLocaleLowerCase();
		// filter match item
		faqArray = faqArray.filter(item => {
			return (
				this.checkIncludes(item.title, searchLow) ||
				item.subItem.some(subItem => {
					return (
						this.checkIncludes(subItem.title, searchLow) ||
						this.checkIncludes(subItem.subTitle, searchLow) ||
						this.checkIncludes(subItem.description, searchLow)
					);
				})
			);
		});
		// control open/close item and subItem
		faqArray = faqArray.map(item => {
			if (
				item.subItem.some(
					subItem =>
						this.checkIncludes(subItem.description, searchLow) ||
						this.checkIncludes(subItem.subTitle, searchLow) ||
						this.checkIncludes(subItem.title, searchLow)
				)
			) {
				item.isOpen = true;
			}

			if (!searchLow) {
				item.isOpen = false;
			}

			item.subItem = item.subItem.map(subItem => {
				if (!searchLow) {
					subItem.isOpen = false;
					return subItem;
				}

				if (this.checkIncludes(subItem.description, searchLow) || this.checkIncludes(subItem.subTitle, searchLow)) {
					subItem.isOpen = true;
				}

				return subItem;
			});

			return item;
		});

		this.faqSubject$.next(faqArray);
	}

	clear() {
		this.searchInput.patchValue('');
	}

	togleIsOpen(mainIndex: number, subIndex: number = undefined) {
		const value = this.faqSubject$.value;

		if (subIndex >= 0) {
			value[mainIndex].subItem[subIndex].isOpen = !value[mainIndex].subItem[subIndex].isOpen;
		}

		if (subIndex === undefined) {
			if (value[mainIndex].isOpen) {
				value[mainIndex].subItem = value[mainIndex].subItem.map(item => {
					item.isOpen = false;
					return item;
				});
			}

			value[mainIndex].isOpen = !value[mainIndex].isOpen;
		}

		this.faqSubject$.next(value);
	}

	async goBack() {
		this.navCtrl.back();
	}
}
